import { cx } from '@platform/core/lib/cx';
import type { IFieldChipGridProps } from './IFieldChipGridProps';

/**
 * Сітка матриці чипів (прототип v4 isChipMx: фактори, тренди): кут і колонки — шапка 11px великими літерами на --surface2, рядки — підпис
 * 600, клітинки (мінімум 84px) з чипами-картками в тоні запису; «гаряча» клітинка — червонуватий фон і примітка великими літерами.
 */
export function FieldChipGrid({ corner, columns, rows }: IFieldChipGridProps) {
  const template = `minmax(120px, 160px) repeat(${columns.length}, minmax(180px, 1fr))`;
  return (
    <div className="fmx-card">
      <div className="fmx-grid" style={{ gridTemplateColumns: template }} role="table">
        <div role="row" style={{ display: 'contents' }}>
          <div className="fmx-corner" role="columnheader">{corner}</div>
          {columns.map((c) => <div key={c} className="fmx-col" role="columnheader">{c}</div>)}
        </div>
        {rows.map((row) => (
          <div key={row.key} role="row" style={{ display: 'contents' }}>
            <div className="fmx-rowh" role="rowheader">{row.label}</div>
            {row.cells.map((cell) => (
              <div key={cell.key} className={cx('fmx-cell', cell.hot && 'is-hot')} role="cell">
                {cell.note && <span className="fmx-cell__note">{cell.note}</span>}
                {cell.chips.map((chip) => (
                  <button key={chip.key} type="button" className={`fmx-chip fmx-tone-${chip.tone ?? 'neutral'}`} title={chip.title} onClick={chip.onClick}>{chip.label}</button>
                ))}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
